<template>
  <div>
    <v-card-title>
      Lens: Used
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              outlined
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            v-on:change="initialize()"
            type="month"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <template>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            outlined
          ></v-text-field>
        </template>
      </v-col>

      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn depressed color="primary" append-icon="mdi-printer" @click="printList"
              >Print
            </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>
    <div id="print">
      <v-card>
        <v-data-table
          :headers="headers"
          :items="itemsWithSno"
          :search="search"
          dense
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      date: new Date().toISOString().substr(0, 7),
      nowDate: new Date().toISOString().substr(0, 7),
      menu2: false,
      loadingstatus: true,
      summary: {},
      headers: [
        {
          text: "#",
          value: "sno",
        },
        {
          text: "OT ID",
          align: "start",
          value: "invoice_id",
        },
        {
          text: "Items",
          value: "invoice_description",
        },
        {
          text: "Operation",
          value: "operation_patient.operation.name",
        },
        {
          text: "Created Date",
          value: "operation_patient.opp_date",
        },
        {
          text: "Bill Date",
          value: "date",
        },
        {
          text: "OT Bill Amount",
          value: "invoice_amount",
        },
        {
          text: "Patient ID",
          value: "operation_patient.patient.patient_id",
        },
        {
          text: "Patient Name",
          value: "operation_patient.patient.patient_name",
        },
        {
          text: "Doctor",
          value: "operation_patient.doctor.dr_name",
        },
      ],

      datalists: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Operations",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
  },
  computed: {
    itemsWithSno() {
      return this.datalists.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {
    initialize() {
      atshq
        .get("lens/lens-report?date=" + this.date)
        .then((response) => {
          this.datalists = response.data.data;

          this.loadingstatus = false;
        })
        .catch((e) => {
          console.log(e);
          this.errors.push(e);
        });
    },

    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write(
        '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );

      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
        "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
        "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
        "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
    dateSelect() {
      this.loadingstatus = true;
      this.initialize();
    },
  },
};
</script>
